@if(model()) {
  <div class="flex flex-col w-full lg:w-3/4 mx-auto">
    <!-- LIO portal handoff — program UI only; the wholesaler API never returns this URL. -->
    @if (isLio && authStore.portal() === 'program' && model().lioIndicationUrl) {
      <div class="flex w-full mb-3">
        <lib-button [cssType]="'btn-primary'" [buttonType]="'button'" [icon]="'rightarrow'" [text]="'View this quote on the LIO portal'" [size]="'small'" (click)="openLioPortal()"></lib-button>
      </div>
    }
    @if ((model().submissionType === 'Renewal' || model().submissionType==='Rewrite') && status() === 'Producer Review') {
      <div class="review-banner ">
        <div>
          <h4>Change Request</h4>
          <p class="medium">Click Manage Submission to modify the details and submit for underwriter review.</p>
        </div>
        <lib-button [cssType]="'btn-primary'" [icon]="'rightarrow'" [text]="'Manage Submission'" [size]="'small'" (click)="manageSubmission()"></lib-button>
      </div>
    }
    <div class="flex w-full">
      <div class="w-1/2">
        <p class="bold">{{ model().businessName }}</p>
        <p><span>Contractors License Number: </span>{{ model().licenseNumber ? model().licenseNumber : ''}}</p>
      </div>
      <div class="w-1/2">
        <p><span class="bold">Retail Agency: </span>{{model().retailAgency}}</p>
        <p><span class="bold">Retail Producer: </span>{{model().retailProducer}}</p>
      </div>
    </div>

    <div class="flex w-full mt-3">
      <div class="w-1/2">
        <p><span class="bold">Business Type: </span>{{model().businessType}}</p>
        <p class="bold">Primary Business Address:</p>
        <p>{{ model().businessAddress}}</p>
        <p>{{model().city}}, {{model().state}} {{model().zipCode}}</p>
      </div>
      <div class="w-1/2">
        <p><span class="bold">Quote Type: </span>{{model().submissionType}}</p>
      </div>
    </div>

    <div class="flex w-full mt-5">
      <div class="w-1/2">
        <p><span class="bold">Annual Gross Receipts: </span> {{model().grossReceipts | currency}}</p>
        <p><span class="bold">Residential Subcontractor Labor Costs (91583):</span> {{model().residentialSubcontractorCosts | currency}}</p>
        <p><span class="bold">Commercial Subcontractor Labor Costs (91585):</span> {{model().commercialSubcontractorCosts | currency}}</p>
        <p><span class="bold">Description of Operations:</span> {{model().descriptionOfOperations}}</p>
      </div>

      <div class="w-1/2">
        @if (hasFieldOwners()) {
          <p><span class="bold">Owners in the Field: </span> {{model().numberOfFieldOwners}}</p>
          <p><span class="bold">Owner Payroll: </span> {{model().ownerPayroll | currency:'USD'}}</p>
        }
        <p><span class="bold">Number of Employees </span> {{model().numberOfEmployees}}</p>
        @if (hasFieldOwners()) {
          <p><span class="bold">Employee Payroll: </span> {{model().employeePayroll | currency:'USD'}}</p>
        }
        <p><span class="bold">Current and Continuous Coverage? </span> {{model().currentAndContinualCoverage}}</p>
        <p><span class="bold">Policy Effective Date: </span> {{model().effectiveDate}}</p>
      </div>
    </div>
  </div>

  @if(model().requestType === 'Bind') {
    <div class="mt-[35px] flex flex-col w-full lg:w-3/4 mx-auto">
      <div class="flex w-full">
        <p class="bold">Documents</p>
      </div>

      <div class="mt-3 flex w-full">
        <div class="w-1/2">
          <p>Signed Application</p>
          @if (viewSubmissionStore.applicationDocuments().length > 0) {
            @for(application of viewSubmissionStore.applicationDocuments(); track application) {
              <lib-button class="underline" [cssType]="'btn-link'" [buttonType]="'button'" [text]="application?.name ?? ''"  [size]="'medium'" (click)="downloadDocument(application?.id ?? '')"></lib-button><br>
            }
          }
        </div>

        <div class="w-1/2">
          <p>Loss Runs</p>
          @if (viewSubmissionStore.lossRunDocuments().length > 0) {
            @for(lossrun of viewSubmissionStore.lossRunDocuments(); track lossrun) {
              <lib-button class="underline" [cssType]="'btn-link'"  [buttonType]="'button'"  [text]="lossrun?.name ?? ''" [size]="'medium'" (click)="downloadDocument(lossrun?.id ?? '')"></lib-button><br>
            }
          }
        </div>
      </div>
    </div>
  }

  <div class="flex flex-col w-full lg:w-3/4 mx-auto">
    @if (model().requestType !== 'Bind') {
      @if (isLio) {
        <!-- LIO classifications are grouped by location: a location sub-header row precedes its classes. -->
        <table class="mt-[35px] submission-review-table">
          <thead>
            <tr>
              <th class="text-left">Classifications</th>
            </tr>
          </thead>
          <tbody>
            @for (location of model().classificationsByLocation ?? []; track location.address) {
              <tr>
                <td class="bold" colspan="2">{{location.address}}</td>
              </tr>
              @for (classification of location.classifications ?? {} | keyvalue; track classification.key) {
                <tr>
                  <td class="pl-4">{{classification.key}}</td>
                  <td class="text-right">{{classification.value | currency:'USD' }}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      } @else if (hasFieldOwners()) {
        <table class="mt-[35px] submission-review-table">
          <thead>
            <tr>
              <th class="text-left">Classifications</th>
              <th class="text-right">Percentage of Work</th>
            </tr>
          </thead>
          <tbody>
            @for (classification of model().classPercentagesOfWork ?? {} | keyvalue; track classification.key) {
              <tr>
                <td>{{classification.key}}</td>
                <td class="text-right">{{classification.value}}%</td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <table class="mt-[35px] submission-review-table">
          <thead>
            <tr>
              <th class="text-left">Classifications</th>
            </tr>
          </thead>
          <tbody>
            @for (classification of model().classifications ?? {} | keyvalue; track classification) {
              <tr>
                <td>{{classification.key}}</td>
                <td class="text-right">{{classification.value | currency:'USD' }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      <div class="flex w-full mt-1">
        <div class="w-full flex justify-end">
          <p class="bold">Total Payroll: {{model().totalPayroll| currency:'USD' }}</p>
        </div>
      </div>
    }

    @if (!isLio && model().percentageOfWork && model().requestType !== 'Bind') {
      <table class="mt-[35px] submission-review-table">
        <thead>
          <tr>
            <th class="text-left">Percentage of Work</th>
          </tr>
        </thead>
        <tbody>
          @for (classification of model().percentageOfWork ?? {} | keyvalue; track classification) {
            <tr>
              <td>{{classification.key}}</td>
              <td class="text-right">{{classification.value}}%</td>
            </tr>
          }
        </tbody>
      </table>
      <div class="flex w-full mt-1">
        <div class="w-full flex justify-end">
          <p class="bold">Total 100%</p>
        </div>
      </div>
    }

    @if (isLio && percentageOfWorkEntries().length > 0) {
      <table class="mt-[35px] submission-review-table">
        <thead>
          <tr>
            <th class="text-left">Percentage of Work</th>
          </tr>
        </thead>
        <tbody>
          @for (entry of percentageOfWorkEntries(); track entry[0]) {
            <tr>
              <td class="text-left">{{ entry[0] }}</td>
              <td class="text-right">{{ entry[1] }}%</td>
            </tr>
          }
        </tbody>
      </table>
    }

    @if (isLio && generalLiabilityCoverage().length > 0) {
      <table class="mt-[35px] submission-review-table">
        <thead>
          <tr>
            <th class="text-left">General Liability Coverage</th>
          </tr>
        </thead>
        <tbody>
          @for (coverage of generalLiabilityCoverage(); track coverage[0]) {
            <tr>
              <td class="text-left">{{ coverage[0] }}</td>
              <td class="text-right">{{ coverage[1] }}</td>
            </tr>
          }
        </tbody>
      </table>
    }

    @if (endorsements().length > 0) {
      <table class="mt-[35px] submission-review-table">
        <thead>
          <tr>
            <th class="text-left">Optional {{ isLio ? 'Coverages' : 'Forms & Coverages' }}</th>
          </tr>
        </thead>
        <tbody>
          @for (endorsement of endorsements(); track endorsement[0]) {
            <tr>
              <td class="text-left">{{ endorsement[0] }}</td>
              <td class="text-right">{{ endorsement[1] }}</td>
            </tr>
          }
        </tbody>
      </table>
    }


    <table class="mt-[35px] submission-review-table">
      <thead>
        <tr>
          <th class="text-left">General Liability Policy Totals</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Rated Premium</td>
          <td class="text-right">{{model().ratedPremium | currency:'USD' }}</td>
        </tr>
        <tr>
          <td>Inspection Fee</td>
          <td class="text-right">{{model().inspectionFee | currency:'USD' }}</td>
        </tr>
        <tr>
          <td>MGA Fee</td>
          <td class="text-right">{{model().mgaFee | currency:'USD' }}</td>
        </tr>
        @for (classification of model().additionalFees ?? {} | keyvalue; track classification) {
          <tr>
            <td>{{classification.key}}</td>
            <td class="text-right">{{classification.value | currency:'USD' }}</td>
          </tr>
        }
        <tr>
          <td>Retail Broker Fee</td>
          <td class="text-right">{{model().brokerFee | currency:'USD' }}</td>
        </tr>
        <tr>
          <td>Surplus Lines Tax</td>
          <td class="text-right">{{model().surplusLinesTax | currency:'USD' }}</td>
        </tr>
        <tr>
          <td>Stamping Office Fee</td>
          <td class="text-right">{{model().stampingOfficeFee | currency:'USD' }}</td>
        </tr>
      </tbody>
    </table>
    @if (!isLio && (authStore.isAdmin() || authStore.isWholesale())) {
      <div class="flex w-full mt-1">
        <div class="w-full flex justify-end">
          <p>Schedule Credit Applied: {{model().scheduleCredit}}</p>
        </div>
      </div>
    }
    <div class="flex w-full mt-1">
      <div class="w-full flex justify-end">
        <h4 class="bold">Quote {{ model().total | currency:'USD' }}</h4>
      </div>
    </div>
  </div>
}